export default __webpack_public_path__ + "static/138-min-min-6ed7205cd38334bfe406dcfebc9d8374.jpg";